import { createContext, useContext } from 'react'
import { FINANCE_COPY, type FinanceCopy } from './locales'

export const FinanceCopyContext = createContext<FinanceCopy>(FINANCE_COPY)

export function useFinanceCopy(): FinanceCopy {
  return useContext(FinanceCopyContext)
}
